import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import axios from 'axios';
import * as FileSaver from 'file-saver';

import { Row, Card, CardBody, Input, Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,Label, Button } from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import ReactTable from "react-table";
import DataTablePagination from "../../../components/DatatablePagination";
import { NotificationManager } from "../../../components/common/react-notifications";

import {
  setContainerClassnames,
  changeDefaultClassnames
} from "../../../redux/actions";

const selectData = [
  { label: "All", value: "all", key: 0 },
  { label: "SELF", value: "online", key: 5 },
  { label: "POS", value: "pos", key: 2 }
];

const users_url = 'https://api.tuatuagye.com/users'
const img_base_url = 'https://api.tuatuagye.com/get-image?type=profile&id='

class Merchants extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      modalOpen: false,
      processing: false,
      confirmModal:false,
      modalViewType:'',
      searchKeyword:'',
      adminCode: '',
      selectedOption: selectData[0],
      selectedUser: {},
      merchants: [],
      total: 0
    }

    this.columns = [
      {
        Header: "Name",
        accessor: "firstname",
        Cell: props => <Row style={{marginLeft:0,marginRight:0,alignItems:'center'}}>
          <img style={{width:50,height:50,borderRadius:25,marginRight:10,backgroundColor:'#eee'}} src={props.original.imageThumbnail ? `${img_base_url}${props.original.imageThumbnail}` : "/assets/img/no-image.jpg"} alt="img"/>
          <span style={{fontSize:16}}>{props.original.firstname} {props.original.lastname}</span>
        </Row>
      },
      {
        Header: "Phone",
        accessor: "phone",
        width:110,
        // headerClassName:'custom-td',
        // className: 'custom-td',
        Cell: props => <p style={{paddingTop:15}} className="text-muted">{props.value}</p>
      },
      // {
      //   Header: "Last Seen",
      //   accessor: "lastSeen",
      //   headerClassName:'custom-td',
      //   className: 'custom-td',
      //   Cell: props => <p className="text-muted"  style={{paddingTop:15, color: props.value === 'Online' ? '#2ECC71':'#4d4d4d'}}>
      //     {this.__formatDate(Number(props.value || props.original.createdAt))}
      //   </p>
      // },
      {
        Header: "Location",
        accessor: "location",
        width: 150,
        Cell: props => <div style={{paddingTop:15}}>{props.value || 'N/A'}</div>
      },
      {
        Header: "Date Joined",
        accessor: "createdAt",
        width: 160,
        Cell: props => <div style={{paddingTop:15}}>{this.__formatDate(props.value)}</div>
      },
      {
        Header: "Status",
        accessor: "enabled",
        width:100,
        Cell: props => <div style={{paddingTop:15}}><span style={{backgroundColor: props.value ? '#2ECC71' : '#E74C3C',color:'#fff',paddingRight:7,paddingLeft:7,paddingTop:5,paddingBottom:5,borderRadius:4}}>{props.value ? 'Active' : 'Inactive'}</span></div>
      },
      {
        Header: "Action",
        accessor: "enabled",
        width:90,
        Cell: props => <Row style={{paddingLeft:"12px",paddingTop:10}}>
          {!props.value && 
            <div
              onClick={()=> {
                this.setState({selectedUser:props.original, modalViewType: 'ENABLE'})
                this.toggleModal();
              }}
              style={{cursor:'pointer',fontSize:20,color:'#2ECC71'}}  
              className={"glyph-icon iconsminds-add-user"} 
            />
          }
          {props.value  && 
            <div 
              onClick={()=> {
                this.setState({selectedUser:props.original, modalViewType: 'DISABLE'})
                this.toggleModal();
              }}
              style={{cursor:'pointer',fontSize:17,paddingTop:5,marginRight:7,paddingLeft:4,color:'#E74C3C'}} 
              className={"glyph-icon simple-icon-close"} 
            />
          }
          <NavLink style={{marginLeft:15,paddingTop:5}} to={`/app/users/merchants/${props.original.id}`}>
            <div style={{fontSize:17}} className={'glyph-icon simple-icon-eye'}/>
          </NavLink>
        </Row>
      }
    ]
  }

  componentDidMount() {
    axios.get(`${users_url}?filter[where][type]=4&filter[order]=createdAt%20DESC`)
      .then(res => {
        if(res.data && res.data.length > 0){
          this.setState({merchants: res.data})
        }
        this.setState({loading:false})
      })
      .catch(error => {
        this.setState({loading: false});
        NotificationManager.error(
          "Loading error",
          "An error occurred. Kindly try again.",
          3000,
          null,
          null,
        );
        console.log('error is',error);
      })

      //REDO. getting total of merchants
      axios.get(`${users_url}?filter[where][type]=4`)
      .then(res => {
        if(res.data && res.data.length > 0){
          this.setState({total: res.data.length})
        }
        this.setState({loading:false})
      })
      .catch(error => {
        this.setState({loading: false});
        NotificationManager.error(
          "Loading error",
          "An error occurred. Kindly try again.",
          3000,
          null,
          null,
        );
        console.log('error is',error);
      })
  }

  searchWithName = (searchText) => {
    this.setState({loading: true});
    // axios.get(`${users_url}/users?filter[where][or][0][firstname][regexp]=/${searchText}/i&filter[where][or][1][lastname][regexp]=/${searchText}/i&filter[where][and][2][type]=4`)
    let query = '';
    let temp = searchText.trim();

    if(temp.split(' ').length > 1){
      query = `filter[where][and][0][firstname][regexp]=/${temp.split(' ')[0]}/i&filter[where][and][1][lastname][regexp]=/${temp.split(' ')[1]}/i&filter[where][and][2][type]=4`
    }
    else {
      query = `filter[where][or][0][firstname][regexp]=/${temp}/i&filter[where][or][1][lastname][regexp]=/${temp}/i&filter[where][or][2][phone][regexp]=/${temp}/i&filter[where][and][3][type]=4`
    }

    axios.get(`${users_url}?${query}&filter[limit]=20`)
      .then(res => {
        if(res.data && res.data.length > 0){
          this.setState({merchants: res.data, loading: false});
          return null;
        }
        else if(temp.split(' ').length > 1){
          query = `filter[where][and][0][firstname][regexp]=/${temp.split(' ')[1]}/i&filter[where][and][1][lastname][regexp]=/${temp.split(' ')[0]}/i&filter[where][and][2][type]=4`;
          return axios.get(`${users_url}?${query}&filter[limit]=20`)
        }
        else {
          this.setState({merchants:[], loading:false});
          return null;
        }
      })
      .then(res=> {
        if(res){
          this.setState({merchants: res.data, loading: false});
        }
      })
      .catch(error => {
        this.setState({loading: false});
        alert('Sorry, an unknown error occurred.');
        console.log('error...',error);
      })
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen
    }))
  }

  handleSubmit = (user) => {
    const { merchants } = this.state
    const enabled = user.enabled ? false : true;

    this.setState({processing:true});

    axios.patch(`${users_url}/${user.id}`,{ enabled })
      .then(res => {
        const temp = merchants.map(usr => {
          if(usr.id === user.id){
            usr.enabled = enabled;
          }

          return usr;
        })

        this.setState({merchants: temp, processing: false, adminCode: ''});
        this.toggleModal();
      })
      .catch(error => {
        this.setState({loading: false});
        console.log('edit eror',error);
        NotificationManager.error(
          "Edit error",
          "An error occurred. Kindly try again.",
          3000,
          null,
          null,
        );
      })
  }

  exportToExcel() {
    const data = this.state.merchants.map(record=> {
      return {
        Name: `${record.firstname} ${record.lastname}`,
        Phone: `${record.phone}`.indexOf('N/A') > -1 ? 'NOT SET':record.phone,
        Email: record.email || 'NOT SET',
        Active: record.enabled ? 'YES':'NO',
        Location: record.location || 'NOT SET',
        'Date Joined': this.__formatDate(record.createdAt)
      }
    })
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, `Merchant Data - ${new Date().toJSON()}`);
    });
  }

  saveAsExcelFile(buffer, fileName) {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  // handleTypeOptionChange = selectedOption => {
  //   if(selectedOption.key !== this.state.selectedOption.key){
  //     this.setState({ selectedOption });
  //     console.log('sel op', selectedOption);
  //     this.setState({loading: true});
  //     axios.get(`${users_url}/users?filter[where][type]=${selectedOption.key}`)
  //       .then(res => {
  //         if(res.data && res.data.length > 0){
  //           this.setState({merchants: res.data, loading: false});
  //         }
  //         else {
  //           this.setState({merchants:[], loading:false})
  //         }
  //       })
  //       .catch(error => {
  //         this.setState({loading: false});
  //         alert('Sorry, an unknown error occurred.');
  //         console.log('error...',error);
  //       })
  //   }
  // };

  formatDate = (_date) => {
    // 3:16pm | Mar 2 2021
    if(!_date) return '';
    const date = new Date(_date);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    
    let strTime = hours + ':' + minutes + '' + ampm;
    
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    
    return `${strTime} | ${months[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;
  }

  // __formatDate = (_date) => {
  //   // 3:16pm | Mar 2 2021
  //   if(!_date) return '';
  //   const date = new Date(_date);
  //   let hours = date.getHours();
  //   let minutes = date.getMinutes();
  //   let ampm = hours >= 12 ? 'pm' : 'am';
  //   hours = hours % 12;
  //   hours = hours ? hours : 12; // the hour '0' should be '12'
  //   minutes = minutes < 10 ? '0'+minutes : minutes;
    
  //   let strTime = hours + ':' + minutes + '' + ampm;
    
  //   let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    
  //   return `${strTime} | ${months[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;
  // }

  __formatDate = (_date) => {
    // 3:16pm | Mar 2 2021
    if(!_date) return '';
    const date = new Date(_date);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    
    let strTime = hours + ':' + minutes + '' + ampm;
    
    let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    let yr = `${date.getFullYear()}`.slice(2);
    return `${strTime} | ${months[date.getMonth()]} ${date.getDate()}, ${yr}`;
  }

  render() {
    const { adminCode, merchants, total, searchKeyword, selectedOption, loading, modalViewType, processing, modalOpen, selectedUser } = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row style={{justifyContent:'space-between',marginLeft:0,marginRight:0}}>
              <h1>Merchants | {total}</h1>
              <Row style={{marginBottom:10,marginLeft:0,marginRight:0}}>
                <div className="payments-search" style={{marginRight:0}}>
                  <Input
                    style={{backgroundColor:'#fff'}}
                    // name="searchKeyword"
                    // id="searchKeyword"
                    placeholder={"Search"
                        // messages["menu.search"]
                    }
                    value={searchKeyword}
                    onChange={e => {
                      let value = e.target.value;
                      this.setState({searchKeyword: value})
                      clearTimeout(this.timer);
                      this.timer = setTimeout(() => {
                        this.searchWithName(value);
                      }, 1000);
                      // this.handleSearchInputChange(e)
                    }}
                    // onKeyPress={e => this.handleSearchInputKeyPress(e)}
                  />
                  <span
                      className="search-icon"
                      style={{top:10}}
                      // onClick={e => this.handleSearchIconClick(e)}
                  >
                      <i className="simple-icon-magnifier" />
                  </span>
                </div>

                {/* <div style={{minWidth:"130px",marginLeft:10}}>
                  <Select
                    components={{ Input: CustomSelectInput }}
                    placeholder='All'
                    className="react-select"
                    classNamePrefix="react-select"
                    name="form-field-name"
                    value={selectedOption}
                    onChange={this.handleTypeOptionChange}
                    options={selectData}
                  />
                </div> */}
                </Row>
              </Row>
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card>
              <CardBody>
                {loading && <div className='loading'/>}
                <ReactTable
                  data={merchants}
                  columns={this.columns}
                  defaultPageSize={100}
                  showPageJump={false}
                  showPageSizeOptions={false}
                  PaginationComponent={DataTablePagination}
                  className={"react-table-fixed-height"}
                />

                <div
                  onClick={()=> {
                    this.exportToExcel();
                  }} 
                  className="d-flex justify-content-end" style={{flex:1,cursor:"pointer"}}>
                  Download to Excel 
                  <div style={{marginLeft:5,marginTop:3}} className={"glyph-icon simple-icon-download"}/>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>


        <Modal
            isOpen={modalOpen}
            toggle={this.toggleModal}
            // className={this.props.className}
          >
            {processing && <div style={{position:'absolute',top:0,left:0,right:0,bottom:0,backgroundColor:'rgba(240,240,240,.5)',zIndex:999}}>
              <div className="loading" />  
            </div>}
            <ModalHeader style={{alignItems:"center",padding:""}} toggle={this.toggleModal}>
                <img style={{width:50,height:50,borderRadius:25,marginRight:10}} src={selectedUser.imageThumbnail ? `${img_base_url}/${selectedUser.imageThumbnail}` : "/assets/img/no-image.jpg"} alt="img"/>
                <Label style={{}}>Edit Merchant Status</Label>
            </ModalHeader>
            <ModalBody>
              {modalViewType === 'ENABLE' ?
                <h6 style={{marginBottom:10}}>Are you sure you want to  <span style={{color:'#2ECC71'}}><b>enable</b></span> <b>{selectedUser.firstname} {selectedUser.lastname}'s</b> account?</h6>
                :
                <h6 style={{marginBottom:10}}>Are you sure you want to <span style={{color:'#E74C3C'}}><b>disable</b></span> <b>{selectedUser.firstname} {selectedUser.lastname}'s</b> account?</h6>
              }
              <h6>Complete transaction by providing your <b>authorization code</b> in the box below</h6>
                <label style={{}}>
                Authorization Code:
                <input type="password" value={adminCode} style={{marginLeft:20,paddingBottom:10,paddingTop:10,outline:'none',width:80}} onChange={(event)=> this.setState({adminCode: event.target.value})} />
                </label>
            </ModalBody>
            <ModalFooter>
            <Button
                color=""
                onClick={this.toggleModal}
            >
                Cancel
            </Button>{" "}
            <Button
                color={modalViewType === 'ENABLE' ? "primary":"danger"}
                onClick={()=> {
                  if(!adminCode){
                      NotificationManager.error(
                          "Authorization Code",
                          "Your security code required to perform this transaction. Thank you.",
                          3000,
                          null,
                          null,
                      );
                  }
                  else if(adminCode !== this.props.user.authCode) {
                      NotificationManager.error(
                          "Invalid Code",
                          "Sorry, the code you entered is invalid. Check and try again.",
                          3000,
                          null,
                          null,
                      );
                  }
                  else {
                    this.handleSubmit(selectedUser);
                  }
                }}
            >
              {modalViewType === 'ENABLE' ? 'Enable':'Disable'} Now
            </Button>
            {/* <div className="loading" /> */}
            </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ menu, authUser }) => {
  const {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems
  } = menu;

  const { user } = authUser;

  return {
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
    user
  };
};

export default connect(
  mapStateToProps,
  {
    setContainerClassnames,
    changeDefaultClassnames
  }
)(Merchants);